/** @jsx jsx */
import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Box, Container, Flex, Grid, jsx, Text } from 'theme-ui'
import MerchCardSimple from '~/components/Merch/Card/Simple'
import PackCardSimple from '~/components/Pack/Card/Simple'

const ProductListSectionCard = ({ listing, type }) => {
  if (type === 'ContentfulMerch') {
    return <MerchCardSimple merch={listing} />
  }

  if (type === 'ContentfulPack') {
    return <PackCardSimple pack={listing} />
  }

  return <Fragment />
}

const ProductListSection = ({ title, listings, cta }) => {
  return (
    <Box pt={[6, 7, null, 9]} pb={[7, 8, null, 10]} bg="backgroundLight">
      <Container>
        {(title || cta) && (
          <Flex
            mb={[5, 4]}
            sx={{
              alignItems: 'center',
              flexDirection: ['column', 'row'],
              justifyContent: ['center', 'space-between'],
            }}
          >
            {title && (
              <Text
                as="h2"
                variant="subtitle1"
                mb={[2, 0]}
                sx={{ color: 'greyDark' }}
              >
                {title}
              </Text>
            )}
            {cta}
          </Flex>
        )}
        <Grid columns={[1, 3]}>
          {listings.map((listing, index) => (
            <ProductListSectionCard
              key={`listing-card-${listing.slug}-${index}`}
              listing={listing}
              type={listing.__typename}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

ProductListSection.propTypes = {
  title: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  cta: PropTypes.shape({}),
}

export default ProductListSection
